<template>
  <div class="create-user-modal1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div
          class="modal-header1 d-flex justify-content-between align-items-center"
        >
          <h5 class="">Permissions</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="close()"
          >
            <i class="fa fa-times modal-close"></i>
          </button>
        </div>
        <div class="modal-body">
          <label class="">Choose Role</label>
          <div class="w-50">
            <Multiselect
              name="designation"
              valueProp="id"
              mode="multiple"
              placeholder="Select Designations"
              :options="roleList"
              :hideSelected="false"
              :closeOnSelect="false"
              class="multiselect-custom-theme"
              size="30"
              @change="onChange($event)"
              v-model="designation"
            >
              <template v-slot:option="{ option }">
                {{ option.name }}
              </template>
            </Multiselect>
          </div>
          <h5 class="tag-title">Users</h5>
          <div class="height-scroll">
            <table class="table fixed-header fixed-column-table">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      id="selectall"
                      @change="selectall()"
                    />
                    Name
                  </th>
                  <th
                    v-for="permissions in permissionList"
                    :key="permissions.id"
                  >
                    <input
                      type="checkbox"
                      :id="permissions.permission"
                      @change="setpermissions(permissions.permission)"
                    />
                    {{ permissions.permission }}
                  </th>
                  <th class="text-center">Save</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="options in userList" :key="options.id">
                  <td>
                    <input
                      type="checkbox"
                      :value="options.userName"
                      :id="options.userId"
                      :checked="
                        userobject[options.userId].permission.length != 0
                      "
                      @change="setcontrols(options)"
                    />
                    {{ options.userName }}
                  </td>
                  <td v-for="option in permissionList" :key="option.id">
                    <input
                      type="checkbox"
                      :value="option.permission"
                      :class="options.id"
                      v-model="userobject[options.userId].permission"
                      @change="selectuserwithpermission(options.userId)"
                    />
                    {{ option.permission }}
                  </td>
                  <td class="text-center">
                    <a href="#">
                      <img
                        src="../../assets/img/save_color.png"
                        class="cursor-pointer"
                        alt="create"
                        @click="createPermission(options.userId)"
                    /></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <label v-if="showSave">
            *Unsaved changes will be lost if switching designations.</label
          >
          <button
            v-if="showSave"
            type="button"
            class="btn btn-primary btn-xs px-4 mr-3"
            @click="createMultiPermission()"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  <script src="./FileFolderProjectPopup.js">
</script>
  <style scoped>
@import "../../assets/css/style.css";
@import "../../assets/css/custom.css";
.create-user-modal1 {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0/18%);
  /* display: flex; */
  /* align-items: center; */
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
  align-items: flex-start !important;
}
.modal-header1 {
  padding: 10px 29px;
  text-align: left;
  display: block;
  border-bottom: 1px solid #dee2e6;
}
.tree input {
  position: inherit !important;
}
.height-scroll {
  height: 250px;
  overflow-y: auto;
}
.fixed-header th {
  top: 0px;
  position: -webkit-sticky;
  position: sticky;
  background-color: #fff;
}

.fixed-column-table th:first-child {
  position: sticky;
  z-index: 2;
  background-color: #f2f2f2;
  left: -1px;
}

.fixed-column-table td:first-child {
  position: sticky;
  z-index: 1;
  background-color: #f2f2f2;
  left: -1px;
}
</style>